import { createContext, useContext, useMemo, useState, useEffect } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        if (typeof window === "undefined") return "de";
        return window.localStorage.getItem("frizerka.lang") || "de";
    });

    useEffect(() => {
        window.localStorage.setItem("frizerka.lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const value = useMemo(() => ({
        lang,
        setLang,
        t: translations[lang] || translations.de,
    }), [lang]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
    return ctx;
}
